import { createFileRoute } from "@tanstack/react-router"
import "modules/auth/lang"

export const Route = createFileRoute("/_base/_public/signup-website")({})
